<div id="dark" class="ipo-bg page-alignment">
    <div *ngIf="mutualFundList?.length>0" class="row mx-2">
        <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
            <div class=" p-4 container-bg radius-20">
                <div
                    class="d-flex flex-wrap justify-content-center mb-3 gradient-container radius-20 gradient-card-padding">
                    <div class="row w-100 justify-content-between align-items-center">
                        <div class="col-10">
                            <div class="row align-items-center">
                                <h3 class="text-light font-xlarge font-600">{{'mutual-fund'|translate}}</h3>
                            </div>
                            <div class="row text-justify">
                                <span class="text-light font-small">{{'mutual-fund-desc'|translate}}</span>
                                <div class="mt-3">
                                    <span class="text-light font-600">{{mutualFundList?.length}}
                                        {{'funds'|translate}}</span>
                                    <img src="assets/img/Thunder.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="col-2">
                            <img class="icon-w-h" src="assets/img/mutual-fund-white.svg" alt="">
                        </div>
                    </div>
                </div>

                <!-- TODO: Hide and show elements in symbols list based on selected type and display tabs based on type in list and number of symbols of types  -->
                <!-- TODO: BackEnd isn't implemented -->
                <div class="types-tab-list d-flex flex-wrap justify-content-center align-item-center">
                    <span class="types-tab-item mx-1">
                        <button
                            class="types-tab types-tab-active"
                            id="selecttab0"
                            (click)="saveTabState($event, 0)"
                        >
                            {{ 'all' | translate }}
                        </button>
                    </span>
                
                    <!-- Dynamic Tabs -->
                    <span class="types-tab-item mx-1" *ngFor="let type of fundTypes">
                        <button
                            class="types-tab"
                            [id]="'selecttab' + type.Id"
                            (click)="saveTabState($event, type.Id)"
                            [class.types-tab-active]="selectedFundType === type.Id"
                        >
                            <div class="number-style my-auto" *ngIf="type.FundCount > 0">{{ type.FundCount }}</div>
                            {{ lang === 'en' ? type.FundTypeEn : type.FundTypeAr }}
                        </button>
                    </span>
                </div>

                <div *ngFor="let fund of mutualFundList let i = index" [class.IPO-selected-card-item]="fund.selected"
                    [class.IPO-unselected-card]="!fund.selected" class="IPO-card padding-15 my-3 clickable"
                    (click)="selectFund(fund)">
                    <div class="d-flex justify-content-between">
                        <div class="row align-items-center mx-1 px-0">
                            <div class="IPO-card-logo-container d-flex align-item-center">
                                <img class="avatar " [src]="fund.IconUrl" alt="">
                            </div>
                            <div class="mx-2 d-flex flex-column align-items-start ">
                                <h5 class="text-color-theme font-medium font-600">{{fund.ReutersCode}}</h5>
                                <h6 class="dimmed-Title font-small">{{ lang=='ar'? fund.FundNameA: fund.FundNameE }}
                                </h6>
                                <h6 class="text-highlight-company-color font-small font-600">{{fund.ClosePrice |
                                    numberFormat }} {{ lang=='ar'? fund.CurrencyAbbreviationA:
                                    fund.CurrencyAbbreviationE }} </h6>
                            </div>
                        </div>
                        <div class="d-flex flex-column align-items-end justify-content-center">
                            <!-- <img src="assets/img/heart-fav-icon.svg" alt=""> -->
                            <div class="text-nowrap">
                                <span class="font-600" [ngClass]="{
                                    'green-text':fund.AnnualChangePercentage>0, 
                                    'red-text':fund.AnnualChangePercentage<0,
                                    'text-color-theme':fund.AnnualChangePercentage==0 }">
                                    % {{fund.AnnualChangePercentage | numberFormat }} <br />
                                    <span>{{'past-year'|translate}}</span>
                                </span>
                                <ng-container *ngIf="fund.AnnualChangePercentage != 0">
                                    <img [src]="fund.AnnualChangePercentage>0?'assets/img/up-arrow.svg':'assets/img/down-arrow.svg'"
                                        alt="">
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" col-sm-12 col-md-12 col-lg-4 col-xl-4 my-2">
            <app-selected-symbol-charts [selectedFund]="selectedFund" [fundDetails]="fundDetails"
                [fundPriceChartData]="fundPriceChartData"></app-selected-symbol-charts>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
            <app-selected-symbol-details-pdfs [fundDetails]="fundDetails"></app-selected-symbol-details-pdfs>
        </div>
    </div>
    <div *ngIf="mutualFundList?.length == 0"
        class="h-100 nodata d-flex flex-column align-items-center justify-content-center">
        <img class="img-container" src="/assets/img/no-data-vector.png" />
        <div class="no-data-available mt-2 font-600"> {{'no-data-available'|translate}} </div>
    </div>
</div>